export default () => {
  const slickElement = $(".js-forms-signatures-slider"),
    nextArrow = $(".js-slider-arrow .btn-next-arrow"),
    prevArrow = $(".js-slider-arrow .btn-prev-arrow");

  slickElement.on("afterChange", function (event, slick, currentSlide) {
    const desctopBreakpoint = 960;

    if ($(window).width() > desctopBreakpoint) {
      var overSlidesCount = 4;
    } else {
      var overSlidesCount = 3;
    }

    let slidesCount = (slick.slideCount - overSlidesCount) + 1;
    
    if(currentSlide === 0) {
      prevArrow.addClass("is-disable");
    } else if(currentSlide === slidesCount) {
      nextArrow.addClass("is-disable");
      prevArrow.removeClass("is-disable");
    } else {
      nextArrow.removeClass("is-disable");
      prevArrow.removeClass("is-disable");
    }
  });
  
  slickElement.slick({
    infinite: false,
    speed: 150,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    adaptiveHeight: true,
    variableWidth: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3
        }
      },
    ]
  });

  nextArrow.click(function (e) {
    slickElement.slick("slickNext");
  });
  prevArrow.click(function (e) {
    slickElement.slick("slickPrev");
  });
}